<script>
	import API from "./API";
	import Room from "./components/Room.svelte";
	import Message from "./components/Message.svelte";

	import Pusher from 'pusher-js'

	let rooms = []
	let messages = {}
	let messagesToDisplay = []
	let activeRoom = null

	let isSettingsOpen = false

	let config = {
		hasLeftBar: true,
		hasBottomBar: true,
		hasMessageControls: true,
		hasFilterControls: true,
		hasSettings: true
	}

	function toogleSettings(e){
		isSettingsOpen = !isSettingsOpen
	}

	function stopProp(e){
		e.stopPropagation()
	}

	async function getRooms() {
		const {data} = await API.get('/groupchat/api/getRooms.php')
		for (let i = 0; i < data.length; i++) {
			data[i].newMessages = 0
			data[i].isActive = false
		}
		return data
	}

	function filtering(filter){
		const messagesAll = messages[activeRoom.idRoom]
		const newDisplay = []
		for(let mess of messagesAll){
			if(mess[filter] == 1){
				newDisplay.push(mess)
			}
		}
		messagesToDisplay = newDisplay
	}

	function sortByLikes(){
		var tab = [...messages[activeRoom.idRoom]]
		var changed;
		do{
			changed = false;
			for(var i=0; i < tab.length-1; i++) {
				if(tab[i].likes.length > tab[i+1].likes.length) {
					var tmp = tab[i];
					tab[i] = tab[i+1];
					tab[i+1] = tmp;
					changed = true;
				}
			}
		} while(changed);
		messagesToDisplay = tab.reverse()
	}

	async function getMessages() {
		const {data} = await API.get('/groupchat/api/getMessages.php')
		for (let message of data) {
			if (messages[message.idRoom] == undefined) {
				messages[message.idRoom] = []
			}
			messages[message.idRoom].push(message)
		}
	}

	function switchRoom(event) {
		console.log()
		messagesToDisplay = messages[event.detail.room.idRoom]
		activeRoom = event.detail.room
		for (let i = 0; i < rooms.length; i++) {
			if (rooms[i].idRoom == event.detail.room.idRoom) {
				rooms[i].isActive = true
			} else {
				rooms[i].isActive = false
			}
		}
		setMode('normal')
	}

	let appName = ''

	function getRoomIndex(id){
		for(let i = 0; i < rooms.length; i++){
			if(rooms[i].idRoom == id){
				console.log(i)
				return i
			}
		}
	}

	var objDiv = document.querySelector('.messages');

	API.get('/groupchat/api/getAppInfo.php').then(response => {
		appName = response.data
		console.log(appName)
		let pusher = new Pusher('2c0a26f798bf140914c9', {
			cluster: 'eu'
		});
		let channel = pusher.subscribe(appName + '-groupchat-admin');
		console.log(channel)
		channel.bind('newMessage', message => {
			console.log(message)
			messages[message.idRoom].push(message)
			filter()
			var objDiv = document.querySelector('.messages');
			if(objDiv.scrollTop != objDiv.scrollHeight){
				rooms[getRoomIndex(message.idRoom)].newMessages ++
				//activeRoom.newMessages ++
			}
		})
		getMessages().then(() => {
			getRooms().then(data => {
				rooms = data
				console.log(rooms)
				console.log(messages)
				for(let room of rooms){
					if(messages[room.idRoom] == undefined){
						messages[room.idRoom] = []
					}
				}
				messagesToDisplay = messages[rooms[0].idRoom]
				rooms[0].isActive = true
				activeRoom = rooms[0]
			})
		})
	})

	let newMessage = ''

	async function sendNewMessage(){
		const { data } = await API.post('/groupchat/api/createAdminMessage.php', {
			idRoom: activeRoom.idRoom,
			message: newMessage
		})
		newMessage = ''
	}

	let mode = 'normal'

	function filter(){
		switch (mode) {
			case 'likes':
				sortByLikes()
				break;
			case 'normal':
				messagesToDisplay = messages[activeRoom.idRoom]
				break;
			case 'tablet':
				filtering('isOnTablet')
				break;
			case 'cast':
				filtering('isCasted')
				break;
			case 'feed':
				filtering('isInFeed')
				break;
		}
	}

	function setMode(newMode){
		if(mode == newMode){
			mode = 'normal'
		}
		else {
			mode = newMode
		}
		filter()
	}

	function editModerationMode(mode){
		activeRoom.moderationMode = mode
		updateRoom()
	}

	function changeRoomParams(param, value){
		activeRoom[param] = value
		updateRoom()
	}

	function changeInterfaceParams(param, value){
		config[param] = value
	}

	async function updateRoom(){
		const { data } = await API.post('/groupchat/api/updateRoom.php', {
			room: activeRoom
		})
	}

	function resetNewMessage(){
		//activeRoom.newMessages = 0
		rooms[getRoomIndex(activeRoom.idRoom)].newMessages = 0
		var objDiv = document.querySelector('.messages');
		objDiv.scrollTop = objDiv.scrollHeight
	}

</script>

<main>
	<div class="chat-interface">
		{#if config.hasLeftBar}
			<div class="chats">
				{#each rooms as room}
					<Room on:room={switchRoom} room={room}/>
				{/each}
			</div>
		{/if}
		<div class="chats-details">
			<div class="room-infos">
				{#if activeRoom != null}
					<p class="roomTitle">{activeRoom.roomName}</p>
					<div class="controls">
						{#if config.hasSettings}
							<span class="material-icons" on:click={toogleSettings}>settings</span>
						{/if}
						{#if config.hasFilterControls}
							{#if activeRoom.hasLikes == 1 || activeRoom.hasTablet == 1 || activeRoom.hasCast == 1 || activeRoom.hasFeed == 1}
								<span class="sep"></span>
							{/if}
							{#if activeRoom.hasLikes == 1}
								<span class="material-icons" on:click={() => setMode('likes')} style="color: {mode == 'likes' ? '#fc0f03' : '#707070'}">favorite</span>
							{/if}
							{#if activeRoom.hasTablet == 1}
								<span class="material-icons" on:click={() => setMode('tablet')} style="color: {mode == 'tablet' ? '#03fcad' : '#707070'}">tablet_mac</span>
							{/if}
							{#if activeRoom.hasCast == 1}
								<span class="material-icons" on:click={() => setMode('cast')} style="color: {mode == 'cast' ? '#027df7' : '#707070'}">cast</span>
							{/if}
							{#if activeRoom.hasFeed == 1}
								<span class="material-icons" on:click={() => setMode('feed')} style="color: {mode == 'feed' ? '#ba05fc' : '#707070'}">playlist_play</span>
							{/if}
						{/if}
					</div>
				{/if}
			</div>
			<div class="messages" class:big={config.hasBottomBar == false}>
				{#each messagesToDisplay as message}
					<Message message={message} config={config} room={activeRoom}/>
				{/each}
				{#if activeRoom != null}
					{#if activeRoom.newMessages > 0}
						<div class="newMess" on:click={resetNewMessage}>
							New messages
						</div>
					{/if}
				{/if}
			</div>
			{#if config.hasBottomBar}
				<div class="message-input">
					<input type="text" bind:value={newMessage}>

					<button on:click={sendNewMessage}>SEND</button>
				</div>
			{/if}
		</div>
	</div>
	{#if isSettingsOpen}
		<div class="settingsModal" on:click={toogleSettings}>
			<div class="settingsModalWindow" on:click={stopProp}>
				<p class="settingsTitle">Room settings</p>
				<section>
					<p class="settingsSectionTitle">Interface options</p>
					<div class="elem">
						<p class="settingsLabel">Display room columns</p>
						<div class="buttons">
							<div class="button" class:selected={config.hasLeftBar} on:click={() => changeInterfaceParams('hasLeftBar', true)}>Yes</div>
							<div class="button" class:selected={!config.hasLeftBar} on:click={() => changeInterfaceParams('hasLeftBar', false)}>No</div>
						</div>
					</div>
					<div class="elem">
						<p class="settingsLabel">Display organization message input</p>
						<div class="buttons">
							<div class="button" class:selected={config.hasBottomBar} on:click={() => changeInterfaceParams('hasBottomBar', true)}>Yes</div>
							<div class="button" class:selected={!config.hasBottomBar} on:click={() => changeInterfaceParams('hasBottomBar', false)}>No</div>
						</div>
					</div>
					<div class="elem">
						<p class="settingsLabel">Display message controls (moderation and diffusion)</p>
						<div class="buttons">
							<div class="button" class:selected={config.hasMessageControls} on:click={() => changeInterfaceParams('hasMessageControls', true)}>Yes</div>
							<div class="button" class:selected={!config.hasMessageControls} on:click={() => changeInterfaceParams('hasMessageControls', false)}>No</div>
						</div>
					</div>
					<div class="elem">
						<p class="settingsLabel">Display filter controls</p>
						<div class="buttons">
							<div class="button" class:selected={config.hasFilterControls} on:click={() => changeInterfaceParams('hasFilterControls', true)}>Yes</div>
							<div class="button" class:selected={!config.hasFilterControls} on:click={() => changeInterfaceParams('hasFilterControls', false)}>No</div>
						</div>
					</div>
					<div class="elem">
						<p class="settingsLabel">Display settings (reload page if you hide this mistakenly)</p>
						<div class="buttons">
							<div class="button" class:selected={config.hasSettings} on:click={() => changeInterfaceParams('hasSettings', true)}>Yes</div>
							<div class="button" class:selected={!config.hasSettings} on:click={() => changeInterfaceParams('hasSettings', false)}>No</div>
						</div>
					</div>
				</section>
				<section>
					<p class="settingsSectionTitle">Room options</p>
					<p class="warning">These options won't be reflected to platform users in real time. Please choose these options wisely before the beginning of the event.
						<br> <br><strong>IF THE EVENT OR THE PRODUCTION HAS STARTED, PLEASE DON'T TOUCH ANY THESE BUTTONS, REALLY BAD THINGS CAN HAPPEN (YOU DON'T WANT THAT)</strong></p>
					<div class="elem">
						<p class="settingsLabel">Room title</p>
						<input type="text" bind:value={activeRoom.roomName} on:input={updateRoom}>
					</div>
					<div class="elem">
						<p class="settingsLabel">Moderation mode</p>
						<div class="buttons">
							<div class="button" class:selected={activeRoom.moderationMode == 'priori'} on:click={() => editModerationMode('priori')}>A priori</div>
							<div class="button" class:selected={activeRoom.moderationMode == 'posteriori'} on:click={() => editModerationMode('posteriori')}>A posteriori</div>
						</div>
					</div>
					<div class="elem">
						<p class="settingsLabel">Room has likes</p>
						<div class="buttons">
							<div class="button" class:selected={activeRoom.hasLikes == 1} on:click={() => changeRoomParams('hasLikes', 1)}>Yes</div>
							<div class="button" class:selected={activeRoom.hasLikes == 0} on:click={() => changeRoomParams('hasLikes', 0)}>No</div>
						</div>
					</div>
					<div class="elem">
						<p class="settingsLabel">Room has a tablet</p>
						<div class="buttons">
							<div class="button" class:selected={activeRoom.hasTablet == 1} on:click={() => changeRoomParams('hasTablet', 1)}>Yes</div>
							<div class="button" class:selected={activeRoom.hasTablet == 0} on:click={() => changeRoomParams('hasTablet', 0)}>No</div>
						</div>
					</div>
					<div class="elem">
						<p class="settingsLabel">Room message can be casted</p>
						<div class="buttons">
							<div class="button" class:selected={activeRoom.hasCast == 1} on:click={() => changeRoomParams('hasCast', 1)}>Yes</div>
							<div class="button" class:selected={activeRoom.hasCast == 0} on:click={() => changeRoomParams('hasCast', 0)}>No</div>
						</div>
					</div>
					<div class="elem">
						<p class="settingsLabel">Room has a feed</p>
						<div class="buttons">
							<div class="button" class:selected={activeRoom.hasFeed == 1} on:click={() => changeRoomParams('hasFeed', 1)}>Yes</div>
							<div class="button" class:selected={activeRoom.hasFeed == 0} on:click={() => changeRoomParams('hasFeed', 0)}>No</div>
						</div>
					</div>
					<div class="elem">
						<p class="settingsLabel">Room is ordered by like on user side</p>
						<div class="buttons">
							<div class="button" class:selected={activeRoom.isClientOrderedByLikes == 1} on:click={() => changeRoomParams('isClientOrderedByLikes', 1)}>Yes</div>
							<div class="button" class:selected={activeRoom.isClientOrderedByLikes == 0} on:click={() => changeRoomParams('isClientOrderedByLikes', 0)}>No</div>
						</div>
					</div>
					<div class="elem">
						<p class="settingsLabel">Messages can be edited by moderator</p>
						<div class="buttons">
							<div class="button" class:selected={activeRoom.messagesCanBeEdited == 1} on:click={() => changeRoomParams('messagesCanBeEdited', 1)}>Yes</div>
							<div class="button" class:selected={activeRoom.messagesCanBeEdited == 0} on:click={() => changeRoomParams('messagesCanBeEdited', 0)}>No</div>
						</div>
					</div>
				</section>
			</div>
		</div>
	{/if}
</main>

<style>

	main {
		width: 100vw;
		height: 95vh;
	}
	.chat-interface {
		display: flex;
		width: 100%;
		height: 100%;
		border: solid 1px #707070;
	}

	.chats {
		width: 25%;
		border-right: solid 1px #707070;
		height: 100%;
		overflow-y: scroll;
	}

	.chats-details {
		flex-grow: 1;
		height: 100%;
		display: flex;
		flex-direction: column;
		position: relative;
	}

	.messages {
		height: 80%;
		margin-top: 0;
		padding: 20px;
		overflow-y: scroll;
	}

	.newMess {
		transform: translate(-50%, -50%);
		width: fit-content;
		padding: 10px 15px;
		font-weight: bold;
		color: white;
		border-radius: 10px;
		background-color: #505050;
		position: absolute;
		bottom: 10%;
		left: 50%;
	}

	.big {
		height: 90%;
	}

	.message-input {
		border-top: solid 1px #707070;
		height: 10%;
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding: 0 15px;
	}

	.message-input input {
		width: 80%;
		padding: 5px 10px;
	}

	.room-infos {
		height: 10%;
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding: 0 15px;
		border-bottom: solid 1px #707070;
	}

	.roomTitle {
		font-weight: 600;
		font-size: 24px;
	}

	.controls {
		display: flex;
		align-items: center;
	}

	.controls span {
		margin: 0 15px;
		color: #707070;
		cursor: pointer;
		display: flex;
	}

	.sep {
		width: 20px;
	}

	.settingsModal {
		width: 100vw;
		height: 100vh;
		background-color: rgba(50, 50, 50, 0.6);
		display: flex;
		align-items: center;
		justify-content: center;
		position: fixed;
		top: 0;
		left: 0;
	}

	.settingsModalWindow {
		width: 60%;
		height: 70%;
		overflow-y: scroll;
		border-radius: 10px;
		background-color: white;
		padding: 20px 25px;
		-ms-overflow-style: none;  /* IE and Edge */
		scrollbar-width: none;
	}

	.settingsModalWindow::-webkit-scrollbar {
		display: none;
	}

	.settingsTitle {
		font-weight: bold;
		font-size: 26px;
		margin-bottom: 20px;
		color: #707070;
	}

	.settingsSectionTitle {
		font-weight: bold;
		font-size: 18px;
		margin-bottom: 10px;
		color: #707070;
	}

	.settingsModalWindow section {
		margin-bottom: 30px;
	}

	.settingsLabel {
		font-weight: bold;
		font-size: 14px;
		color: #505050;
		margin-bottom: 10px;
	}

	.settingsModalWindow input {
		padding: 5px 10px;
		width: 100%;
	}

	.elem {
		margin-bottom: 10px;
	}

	.warning {
		font-size: 12px;
		color: #cc4b4b;
		margin-bottom: 18px;
	}
	.buttons {
		display: flex;
		align-items: center;
		border-radius: 12px;
		border: 1px solid #707070;
		width: fit-content;
		overflow: hidden;
	}

	.button {
		padding: 7px 15px;
		color: #707070;
		font-weight: bold;
		cursor: pointer;
		font-size: 14px;
	}

	.button.selected {
		background-color: #707070;
		color: white;
	}
</style>